export default "__VITE_ASSET__ZlQ8AqNC__"